export default __webpack_public_path__ + "static/media/languages_icon.061f24db.svg";